"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = Card;
const jsx_runtime_1 = require("react/jsx-runtime");
const utilities_1 = require("@kalkulacka-one/design-system/utilities");
const class_variance_authority_1 = require("class-variance-authority");
const CardVariants = (0, class_variance_authority_1.cva)("ko:rounded-3xl", {
    variants: {
        color: {
            white: "ko:bg-white",
            transparent: "ko:bg-transparent",
        },
        corner: { topRight: "ko:rounded-tr-none", topLeft: "ko:rounded-tl-none", bottomRight: "ko:rounded-br-none", bottomLeft: "ko:rounded-bl-none" },
        border: {
            true: "ko:border ko:border-neutral",
            false: "",
        },
        shadow: {
            elevated: "ko:drop-shadow-2xl",
            hard: "ko:drop-shadow-hard",
            false: "",
        },
        interactive: {
            true: "",
            false: "",
        },
    },
    defaultVariants: {
        color: "white",
        corner: "topLeft",
        border: false,
        shadow: true,
        interactive: false,
    },
});
function Card({ children, color, corner, border, shadow, interactive, className }) {
    return (0, jsx_runtime_1.jsx)("div", { className: (0, utilities_1.twMerge)(CardVariants({ color, corner, border, shadow, interactive }), className), children: children });
}
